// extracted by mini-css-extract-plugin
export default {"discountBanner":"qga","topheader":"rga","navleft":"sga","navflexelem":"tga","navright":"uga","fixedtop":"vga","abstop":"wga","subdesc":"xga","smallscreennav":"yga","nav_hidden":"zga","cancel_link":"Aga","bottomnavcontainer":"Bga","fixedbottom":"Cga","animatedbottom":"Ega","appear-bottom":"Fga","delayedbottom":"Gga","retakebtn":"Hga","long_banner":"Iga","nofixed":"Jga"};
    if(module.hot) {
      // 1738836199279
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  